import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <header>
        <Navbar />
      </header>
      <main className="pt-24 md:pt-28 px-4 md:px-8 lg:px-12">
        <div className="max-w-xl mx-auto text-center py-16 md:py-24">
          <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center mx-auto mb-6 rounded-full bg-background-100">
            <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-foreground-300">
              <i className="ri-error-warning-line text-3xl md:text-4xl" />
            </span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-3">404</h1>
          <p className="text-lg text-foreground-500 mb-2">页面未找到</p>
          <p className="text-sm text-foreground-400 mb-8">
            您访问的页面不存在或已被移除，去看看其他精彩内容吧
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/category/entertainment"
              className="bg-background-100 text-foreground-700 border border-background-300 px-8 py-3 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
            >
              浏览热门爆料
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}